import { lazy } from 'react';

export default lazy(
  () =>
    import(
      /* webpackChunkName: "simple-search-screen" */
      './SimpleSearch'
    )
);
